import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import cuid from 'cuid';
import ColorInput from './ColorInput';
import ColorSwatch from './ColorSwatch';
import ColorLabel from './ColorLabel';
import ColorIcon from './ColorIcon';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
import { calculateSpacing, colors } from '@vds-core/theme';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * @deprecated
   * If provided, the className will be rendered.
   */
  className: PropTypes.string,

  /**
   * If provided, the color of the RadioSwatch will be rendered.
   */
  color: PropTypes.string,

  /**
   * @deprecated
   * If provided, the RadioSwatch will be rendered in the Disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * If provided, the label of the RadioSwatch will be rendered.
   */
  label: PropTypes.string,

  /**
   * Name of RadioSwatch.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback function that returns the value of the RadioSwatch when clicked.
   */
  onChange: PropTypes.func,

  /**
   * Value of RadioSwatch.
   */
  value: PropTypes.string.isRequired,

  /**
   * If provided, the Radio will be rendered in the Selected State.
   */
  selected: PropTypes.bool,

  /**
   * @deprecated
   * If provided, the Radio will be rendered in the Selected State.
   */
  checked: PropTypes.bool,

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  focusSize: PropTypes.func,

  /**
   * @ignore
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  labelMargin: PropTypes.number,

  /**
   * @ignore
   */
  labelMaxWidth: PropTypes.number,

  /**
   * @ignore
   */
  labelMinWidth: PropTypes.number,

  /**
   * @ignore
   */
  swatchMargin: PropTypes.func,

  /**
   * @ignore
   */
  size: PropTypes.number,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  typographyConfig: PropTypes.object,

  /**
   * @ignore
   */
  selectedStateDoubleBorder: PropTypes.bool,

  /**
   * @ignore
   */
  outOfStock: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the input element.
   */
  inputId: PropTypes.string,

  /**
   * @ignore
   */
  disabledState: PropTypes.bool
}; //Move to VDS

function _determineSwatchMargin() {
  return "".concat(calculateSpacing('1X'), " auto");
}

var defaultProps = {
  className: null,
  color: 'Black',
  disabled: false,
  label: null,
  name: null,
  onClick: function onClick() {},
  onChange: function onChange() {},
  selected: false,
  //1.0
  bodyConfig: BodyConfig,
  focusSize: undefined,
  focusState: false,
  labelMargin: 2,
  labelMaxWidth: 56,
  labelMinWidth: 56,
  swatchMargin: _determineSwatchMargin,
  size: 25,
  typographyConfig: TypographyConfig,
  selectedStateDoubleBorder: false,
  outOfStock: false,
  disabledState: true,
  colorConfig: colors //Deprecated
  //checked: false

};
var SwatchWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SwatchWrapper",
  componentId: "e2v80q-0"
})(_templateObject());

var RadioSwatch = function RadioSwatch(props) {
  var checked = props.checked,
      color = props.color,
      disabled = props.disabled,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      onClick = props.onClick,
      selected = props.selected,
      idProp = props.id,
      bodyConfig = props.bodyConfig,
      typographyConfig = props.typographyConfig,
      value = props.value,
      focusSize = props.focusSize,
      focusState = props.focusState,
      labelMargin = props.labelMargin,
      labelMaxWidth = props.labelMaxWidth,
      labelMinWidth = props.labelMinWidth,
      swatchMargin = props.swatchMargin,
      size = props.size,
      typescale = props.typescale,
      selectedStateDoubleBorder = props.selectedStateDoubleBorder,
      outOfStock = props.outOfStock,
      disabledState = props.disabledState,
      colorConfig = props.colorConfig,
      numberOfSwatches = props.numberOfSwatches,
      analyticsTrack = props['data-analyticstrack'],
      track = props['data-track'],
      clickStream = props['data-clickstream'],
      inputId = props.inputId;
  var radioId = inputId ? inputId : cuid();

  function _checkIfIe() {
    var isAriaHidden = false;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');

    if (msie > 0) {
      isAriaHidden = true;
    }

    var trident = ua.indexOf('Trident/');

    if (trident > 0) {
      isAriaHidden = true;
    }

    return isAriaHidden;
  }

  function _onKeyDown(e, numberOfSwatches) {
    if (!onClick) return; // if we get an arrow key input, pass event to _onChange

    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();

      _onChange(e, numberOfSwatches);
    }

    if (e.key === 'Enter' || e.key === ' ') {
      onChange(e);
    }
  }

  function _onChange(e, numberOfSwatches) {
    if (!onClick) return; // for click events

    if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
      e.target.blur();
      onChange(e);
    } // when an event comes in from _onKeyDown
    else {
        var prevRadio = e.target.parentNode.previousElementSibling;
        var nextRadio = e.target.parentNode.nextElementSibling;
        var firstId = "swatchId".concat(1);
        var lastId = "swatchId".concat(numberOfSwatches);
        var firstRadio = document.getElementById(firstId);
        var lastRadio = document.getElementById(lastId);

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          if (nextRadio) {
            nextRadio.focus();
          } else {
            firstRadio.focus();
          }
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          if (prevRadio) {
            prevRadio.focus();
          } else {
            lastRadio.focus();
          }
        }
      }
  }

  var labelText = disabled || outOfStock ? label + ' - Out of Stock' : label,
      isSelected = checked || selected;
  var ariaDisplay = value;

  var noop = function noop(e) {
    e.target.blur();
  }; //If outOfStock
  //Colorswatch
  //ColorIcon


  return /*#__PURE__*/React.createElement(ColorLabel, _extends({}, props, {
    id: idProp,
    bodyConfig: bodyConfig,
    disabled: disabled && disabledState,
    outOfStock: outOfStock,
    labelMargin: labelMargin,
    labelMaxWidth: labelMaxWidth,
    labelMinWidth: labelMinWidth,
    typescale: typescale,
    typographyConfig: typographyConfig,
    focusSize: focusSize,
    colorConfig: colorConfig
  }), /*#__PURE__*/React.createElement(ColorInput, {
    numberOfSwatches: numberOfSwatches,
    checked: isSelected,
    focusSize: focusSize,
    focusState: focusState,
    id: radioId,
    onChange: noop,
    onClick: disabled && disabledState ? function (e) {
      return noop(e);
    } : function (e) {
      return _onChange(e, numberOfSwatches);
    },
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e, numberOfSwatches);
    },
    role: "radio",
    size: size,
    tabIndex: isSelected ? 0 : -1,
    type: "radio",
    value: value,
    colorConfig: colorConfig,
    outOfStock: outOfStock,
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-clickstream": clickStream
  }), /*#__PURE__*/React.createElement(ColorSwatch, {
    active: isSelected,
    color: color,
    disabled: disabled || outOfStock,
    outOfStock: outOfStock,
    selected: isSelected,
    swatchMargin: swatchMargin,
    size: size,
    tabIndex: -1,
    colorConfig: colorConfig
  }, /*#__PURE__*/React.createElement(ColorIcon, {
    disabled: disabled && disabledState,
    outOfStock: outOfStock,
    selected: isSelected,
    tabIndex: -1,
    value: value,
    selectedStateDoubleBorder: selectedStateDoubleBorder,
    colorConfig: colorConfig
  })), /*#__PURE__*/React.createElement(SwatchWrapper, {
    "aria-hidden": _checkIfIe(),
    tabIndex: -1
  }, labelText));
};

RadioSwatch.propTypes = propTypes;
RadioSwatch.defaultProps = defaultProps;
export default withVDSManager(RadioSwatch);